var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Download your flyer below "),_c('DineToDonate',{staticClass:"my-3",attrs:{"event":_vm.event,"restaurant":_vm.restaurant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }